import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ICreateMealtimeCategoriesResponse } from './types';
import { ICategoryResponse } from '../getCategories/types';

export const createMealtimeCategories = async (
  menuId: string,
  mealtimeId: string,
  categoryIds: string[],
): Promise<ICategoryResponse> => {
  try {
    const response = await fetch(`${API_URL}/menus/${menuId}/mealtimes/${mealtimeId}/sections`, {
      method: 'PUT',
      body: JSON.stringify({ sections: categoryIds }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error();
    }

    const { data }: ICreateMealtimeCategoriesResponse = await response.json();
    return data[0];
  } catch (e) {
    throw new Error('Something went wrong whilst assigning categories to a mealtime');
  }
};
